// extracted by mini-css-extract-plugin
export default {"player-detail":"index_player-detail__8Tv1W"};